// Helpers
import { getDirection } from 'helpers/system'

// Data (Local)
const actionGroupName = 'SYSTEM'

// Constants (Local)
const SYSTEM_ACTIONS = Object.freeze({
	CHANGE_LANGUAGE: `CHANGE_${actionGroupName}_LANGUAGE`,
	CHANGE_THEME: `CHANGE_${actionGroupName}_THEME`
})

// Reducer: System
function system (state, action) {
	// Actions
	switch (action.type) {
		// Action: Change language
		case SYSTEM_ACTIONS.CHANGE_LANGUAGE:
			return {
				...state,
				direction: getDirection(action.payload),
				language: action.payload
			}
		// Action: Change theme
		case SYSTEM_ACTIONS.CHANGE_THEME:
			return {
				...state,
				theme: action.payload
			}
		// Fallback
		default:
			return state
	}
}

// Export
export default system
export {
	SYSTEM_ACTIONS
}
